import React from "react"
import {
  FormContainer,
  Worksheet,
  CheckboxYesNo,
  DatePicker,
  LabeledInput
  // formatCurrency
} from "uikit"
import { paymentFrequencyOptions } from "components/incomes/dropDownOptions"
import { Dropdown } from "semantic-ui-react"
import { parse as parseDate, differenceInCalendarMonths } from "date-fns"
import { Footer } from "./Footer"
import { useStore } from "store"

const workPausePayFrequencyOptions = [
  ...paymentFrequencyOptions,
  { text: "Once a Quarter", value: "quarterly" },
  { text: "Twice a Year", value: "semiannually" },
  { text: "Once a Year", value: "annually" }
]

const WorkPauseForm = ({
  data: {
    fields: {
      subtype,
      person_id,
      is_covid19_hardship,
      start_date,
      end_date,
      employment_income,
      employment_pay_frequency,
      prior_employment_income,
      selfemployment_income,
      selfemployment_pay_frequency,
      prior_selfemployment_income,
      unemployment_income,
      unemployment_pay_frequency,
      onetime_assistance,
      monthly_medical_expenses,
      is_employer_hsa_contribution_suspended,
      is_esrp_employer_contribution_suspended,
      is_esrp_match_suspended,
      is_esrp_covid_withdrawal_allowed,
      is_esrp_loan_allowed,
      is_esrp_loan_covid_enhanced,
      esrp_loan_interest_rate,
      esrp_loan_term_years,
      is_other_loan_available,
      other_loan_interest_rate,
      other_loan_term_years,
      other_loan_max_amount
    },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  baseUrl,
  peopleHsa,
  peopleOptions,
  subtypeOptions,
  isNew
}) => {
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row label="Whose employment is impacted?" paddedField>
          <Worksheet.Field error={person_id.error}>
            <Dropdown
              {...person_id}
              selection
              fluid
              placeholder="Person"
              options={peopleOptions}
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="How is employment impacted?" paddedField>
          <Worksheet.Field error={subtype.error}>
            <Dropdown
              {...subtype}
              selection
              fluid
              placeholder="Employment"
              options={subtypeOptions}
            />
          </Worksheet.Field>
        </Worksheet.Row>
        {/* <Worksheet.Row label="Is this hardship related to COVID-19?" paddedField>
        <Worksheet.Field>
          <CheckboxYesNo
            fluid
            {...is_covid19_hardship}
            data-testid="isCovid19Hardship"
          />
        </Worksheet.Field>
      </Worksheet.Row> */}
        <Worksheet.Row label="How long do you expect the hardship to last?">
          <Worksheet.Row label="When did/will it start?" paddedField>
            <Worksheet.Field error={start_date.error}>
              <DatePicker {...start_date} />
            </Worksheet.Field>
          </Worksheet.Row>
          <Worksheet.Row
            label="When do you expect it to end?"
            description="You may not know and that's okay. It typically takes anywhere from a few weeks to a few months to find a new job or get back to normal."
            paddedField
          >
            <Worksheet.Field error={end_date.error}>
              <DatePicker {...end_date} />
            </Worksheet.Field>
          </Worksheet.Row>
        </Worksheet.Row>
        <Worksheet.Row label="What about employment income reported on a W&#8209;2">
          <Worksheet.Row
            label="Employment income per pay period PRIOR to this hardship"
            description="Leave blank if it was the same as what you are planning for after this crisis."
            paddedField
          >
            <Worksheet.Field error={prior_employment_income.error}>
              <LabeledInput
                {...prior_employment_income}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder=""
              />
            </Worksheet.Field>
          </Worksheet.Row>
          <Worksheet.Row
            label="Employment income per pay period DURING this hardship"
            paddedField
          >
            <Worksheet.Field error={employment_income.error}>
              <LabeledInput
                {...employment_income}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder="0"
              />
            </Worksheet.Field>
          </Worksheet.Row>
          <Worksheet.Row
            label="Employment income paycheck frequency"
            paddedField
          >
            <Worksheet.Field error={employment_pay_frequency.error}>
              <Dropdown
                placeholder="Frequency"
                selection
                options={workPausePayFrequencyOptions}
                data-testid="pay_frequency"
                {...employment_pay_frequency}
              />
            </Worksheet.Field>
          </Worksheet.Row>
        </Worksheet.Row>
        <Worksheet.Row label="What about self-employment income reported on a 1099, K-1 or your Schedule C?">
          <Worksheet.Row
            label="Self-employment income per pay period PRIOR to this hardship"
            description="Leave blank if it was the same as what you are planning for after this crisis."
            paddedField
          >
            <Worksheet.Field error={prior_selfemployment_income.error}>
              <LabeledInput
                {...prior_selfemployment_income}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder=""
              />
            </Worksheet.Field>
          </Worksheet.Row>
          <Worksheet.Row
            label="Self-employment income per pay period DURING this hardship"
            paddedField
          >
            <Worksheet.Field error={selfemployment_income.error}>
              <LabeledInput
                {...selfemployment_income}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder="0"
              />
            </Worksheet.Field>
          </Worksheet.Row>
          <Worksheet.Row
            label="Self-employment income payment frequency"
            paddedField
          >
            <Worksheet.Field error={selfemployment_pay_frequency.error}>
              <Dropdown
                placeholder="Frequency"
                selection
                options={workPausePayFrequencyOptions}
                data-testid="pay_frequency"
                {...selfemployment_pay_frequency}
              />
            </Worksheet.Field>
          </Worksheet.Row>
        </Worksheet.Row>
        <Worksheet.Row label="What unemployment income do expect during this time?">
          <Worksheet.Row label="Unemployment per pay period" paddedField>
            <Worksheet.Field error={unemployment_income.error}>
              <LabeledInput
                {...unemployment_income}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder="0"
              />
            </Worksheet.Field>
          </Worksheet.Row>
          <Worksheet.Row
            label="Unemployment benefit payment frequency"
            paddedField
          >
            <Worksheet.Field error={unemployment_pay_frequency.error}>
              <Dropdown
                placeholder="Frequency"
                selection
                options={paymentFrequencyOptions}
                data-testid="pay_frequency"
                {...unemployment_pay_frequency}
              />
            </Worksheet.Field>
          </Worksheet.Row>
        </Worksheet.Row>
        {is_covid19_hardship.object ? (
          <Worksheet.Row
            label="If you haven’t yet received a stimulus check, how much do you expect to receive?"
            paddedField
          >
            <Worksheet.Field error={onetime_assistance.error}>
              <LabeledInput
                {...onetime_assistance}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder="0"
              />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
        <Worksheet.Row
          label="What will your monthly medical expenses be during this hardship?"
          description={
            <>
              Leave blank if it is the same as what you're planning for after
              this hardship.{" "}
              <strong>
                Include your COBRA payments if using COBRA during this crisis.
              </strong>
            </>
          }
          paddedField
        >
          <Worksheet.Field error={monthly_medical_expenses.error}>
            <LabeledInput
              {...monthly_medical_expenses}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder=""
            />
          </Worksheet.Field>
        </Worksheet.Row>
        {subtype.value &&
        subtype.value !== "unemployment" &&
        person_id.value !== "" &&
        peopleHsa[person_id.value] ? (
          <Worksheet.Row
            label="Will your employer suspend HSA contributions during this time?"
            paddedField
          >
            <Worksheet.Field>
              <CheckboxYesNo
                fluid
                {...is_employer_hsa_contribution_suspended}
              />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
        {is_covid19_hardship.object &&
        subtype.value &&
        subtype.value === "furlough" ? (
          <Worksheet.Row
            label="Does your employer allow COVID-related withdrawals without penalty from your retirement plan?"
            paddedField
          >
            <Worksheet.Field>
              <CheckboxYesNo fluid {...is_esrp_covid_withdrawal_allowed} />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
        {subtype.value && subtype.value !== "unemployment" ? (
          <Worksheet.Row
            label="Will your employer suspend matching on your retirement plan contributions?"
            paddedField
          >
            <Worksheet.Field>
              <CheckboxYesNo fluid {...is_esrp_match_suspended} />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
        {subtype.value && subtype.value !== "unemployment" ? (
          <Worksheet.Row
            label="Will your employer stop making any direct retirement plan contributions?"
            paddedField
          >
            <Worksheet.Field>
              <CheckboxYesNo
                fluid
                {...is_esrp_employer_contribution_suspended}
              />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
        {subtype.value && subtype.value !== "unemployment" ? (
          <Worksheet.Row
            label="Does your employer allow you to take loans from your retirement plan?"
            description="Please remember that you need to pay back those loans immediately upon separation from your employer!"
            paddedField
          >
            <Worksheet.Field>
              <CheckboxYesNo fluid {...is_esrp_loan_allowed} />
            </Worksheet.Field>
            {is_covid19_hardship.object && is_esrp_loan_allowed.object ? (
              <Worksheet.Row
                label="Does your employer make available a COVID-related loan?"
                description="COVID-related loans can be larger and you do not have to start paying until January 1st, 2021 although interest will accrue."
                paddedField
              >
                <Worksheet.Field>
                  <CheckboxYesNo fluid {...is_esrp_loan_covid_enhanced} />
                </Worksheet.Field>
              </Worksheet.Row>
            ) : null}
            {is_esrp_loan_allowed.object ? (
              <Worksheet.Row
                label="What annual interest rate would you pay on a loan from your retirement plan?"
                paddedField
              >
                <Worksheet.Field error={esrp_loan_interest_rate.error}>
                  <LabeledInput
                    {...esrp_loan_interest_rate}
                    label=""
                    iconText="%"
                    iconPosition="right"
                    placeholder="0"
                  />
                </Worksheet.Field>
              </Worksheet.Row>
            ) : null}
            {is_esrp_loan_allowed.object ? (
              <Worksheet.Row
                label="From the moment you start paying, how many years do you have to pay back the loan?"
                description={
                  <>
                    The IRS limits the maximum term to five years, which is what
                    many employers make available.{" "}
                    <strong>
                      Remember you need to pay these loans off immediately upon
                      separation
                    </strong>
                    , so please adjust the term if you expect to leave this
                    employer.
                  </>
                }
                paddedField
              >
                <Worksheet.Field error={esrp_loan_term_years.error}>
                  <LabeledInput
                    {...esrp_loan_term_years}
                    label=""
                    iconText="years"
                    iconPosition="right"
                    placeholder="0"
                  />
                </Worksheet.Field>
              </Worksheet.Row>
            ) : null}
          </Worksheet.Row>
        ) : null}
        <Worksheet.Row
          label="Do you have other financing available?"
          description="You may want to consider home equity loans, personal loans or even credit cards with exceptional rates."
          paddedField
        >
          <Worksheet.Field>
            <CheckboxYesNo fluid {...is_other_loan_available} />
          </Worksheet.Field>
          {is_other_loan_available.object ? (
            <Worksheet.Row
              label="What annual interest rate (APR) would you pay on this loan?"
              paddedField
            >
              <Worksheet.Field error={other_loan_interest_rate.error}>
                <LabeledInput
                  {...other_loan_interest_rate}
                  label=""
                  iconText="%"
                  iconPosition="right"
                  placeholder="0"
                />
              </Worksheet.Field>
            </Worksheet.Row>
          ) : null}
          {is_other_loan_available.object ? (
            <Worksheet.Row
              label="Over how many years would you need to pay back the loan?"
              paddedField
            >
              <Worksheet.Field error={other_loan_term_years.error}>
                <LabeledInput
                  {...other_loan_term_years}
                  label=""
                  iconText="years"
                  iconPosition="right"
                  placeholder="0"
                />
              </Worksheet.Field>
            </Worksheet.Row>
          ) : null}
          {is_other_loan_available.object ? (
            <Worksheet.Row
              label="What is the maximum amount you could borrow?"
              paddedField
            >
              <Worksheet.Field error={other_loan_max_amount.error}>
                <LabeledInput
                  {...other_loan_max_amount}
                  label=""
                  iconText="$"
                  iconPosition="left"
                  placeholder="0"
                />
              </Worksheet.Field>
            </Worksheet.Row>
          ) : null}
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        baseUrl={baseUrl}
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        isPending={isPending}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Goal"
        error={error}
      />
    </Worksheet>
  )
}

const WorkPauseFormContainer = FormContainer(
  {
    person_id: {
      type: "string"
    },
    subtype: {
      type: "string"
    },
    is_covid19_hardship: {
      type: "boolean",
      defaultValue: true
    },
    start_date: {
      type: "date"
    },
    end_date: {
      type: "date"
    },
    employment_income: {
      type: "unit",
      required: false,
      defaultValue: 0
    },
    employment_pay_frequency: {
      type: "string",
      required: false,
      defaultValue: "biweekly"
    },
    prior_employment_income: {
      type: "unit",
      required: false
    },
    selfemployment_income: {
      type: "unit",
      required: false,
      defaultValue: 0
    },
    selfemployment_pay_frequency: {
      type: "string",
      required: false,
      defaultValue: "monthly"
    },
    prior_selfemployment_income: {
      type: "unit",
      required: false
    },
    unemployment_income: {
      type: "unit",
      required: false,
      defaultValue: 0
    },
    unemployment_pay_frequency: {
      type: "string",
      required: false,
      defaultValue: "weekly"
    },
    onetime_assistance: {
      type: "unit",
      required: false,
      defaultValue: 0
    },
    monthly_medical_expenses: {
      type: "unit",
      required: false
    },
    is_employer_hsa_contribution_suspended: {
      type: "boolean",
      defaultValue: true
    },
    is_esrp_employer_contribution_suspended: {
      type: "boolean",
      required: false
    },
    is_esrp_match_suspended: {
      type: "boolean",
      required: false
    },
    is_esrp_covid_withdrawal_allowed: {
      type: "boolean",
      required: false
    },
    is_esrp_loan_allowed: {
      type: "boolean",
      required: false
    },
    is_esrp_loan_covid_enhanced: {
      type: "boolean",
      required: false
    },
    esrp_loan_interest_rate: {
      type: "decimal",
      required: false,
      minValue: 0,
      maxValue: 20
    },
    esrp_loan_term_years: {
      type: "unit",
      required: false,
      minValue: 1,
      maxValue: 5
    },
    is_other_loan_available: {
      type: "boolean",
      required: false
    },
    other_loan_interest_rate: {
      type: "decimal",
      required: false,
      minValue: 0,
      maxValue: 20
    },
    other_loan_term_years: {
      type: "unit",
      required: false,
      minValue: 1,
      maxValue: 30
    },
    other_loan_max_amount: {
      type: "unit",
      required: false,
      minValue: 500
    },
    type: {
      type: "string",
      defaultValue: "workpause"
    }
  },
  ({ fields }, ...form) => {
    const start_date =
      fields.start_date.value && parseDate(fields.start_date.value)
    const end_date = fields.end_date.value && parseDate(fields.end_date.value)
    if (start_date && start_date.getFullYear > new Date().getFullYear()) {
      return {
        fields: {
          start_date: "Hardship period must start this year."
        }
      }
    }
    if (
      end_date &&
      start_date &&
      differenceInCalendarMonths(end_date, start_date) < 1
    ) {
      return {
        fields: {
          start_date: "Must start at least a month before it ends",
          end_date: "Must end at least a month after it starts"
        }
      }
    } else {
      return {
        fields: {
          start_date: "",
          end_date: ""
        }
      }
    }
  }
)(WorkPauseForm)

const WorkPause = ({ household, scenario, goal, ...formProps }) => {
  const [people] = useStore("householdPeople", household.id)
  const [goals] = useStore("scenarioGoals", scenario.id)
  const { addGoal, updateGoal, deleteGoal } = useStore()
  const [benefitsObject] = useStore("householdBenefits", household.id)
  const [incomes] = useStore("householdIncomes", household.id)

  const isNew = goal === null

  const values = isNew ? {} : { ...goal, is_covid19_hardship: true }

  const subtypeOptions = [
    // { value: "normal", text: "No Change" },
    { value: "furlough", text: "Furloughed" },
    { value: "unemployment", text: "Laid-off/Unemployed" },
    { value: "reduced", text: "Reduced" }
  ]

  const excludedPeopleIds = Object.values(goals)
    .filter(
      otherGoal =>
        otherGoal.type === "workpause" && (isNew || otherGoal.id !== goal.id)
    )
    .map(otherGoal => otherGoal.person_id)

  const peopleHsa = {}
  const benefits = Object.values(benefitsObject)
  benefits
    .filter(({ type, is_hdhp }) => type === "eshc_plan" && is_hdhp === true)
    .map(({ income_id, people_coverage, covered_people }) => {
      if (people_coverage === "individual") {
        peopleHsa[incomes[income_id]["person_id"]] = true
      } else if (people_coverage === "family") {
        Object.keys(people).forEach(p => (peopleHsa[p] = true))
      } else if (people_coverage === "other") {
        covered_people.forEach(cv => (peopleHsa[cv.person_id] = true))
      }
      return true
    })

  const peopleOptions = Object.values(people)
    .filter(
      person =>
        (person.role === "spouse" || person.role === "client") &&
        !excludedPeopleIds.includes(person.id)
    )
    .map(({ id: value, first_name: text }) => ({
      value,
      text
    }))

  const submit = async values => {
    let modifiedValues = { ...values }
    modifiedValues["is_covid19_hardship"] = true
    if (modifiedValues.subtype === "unemployment") {
      modifiedValues["is_esrp_loan_allowed"] = false
      modifiedValues["is_esrp_covid_withdrawal_allowed"] = false
      modifiedValues["is_esrp_employer_contribution_suspended"] = true
      modifiedValues["is_esrp_match_suspended"] = true
      modifiedValues["is_employer_hsa_contribution_suspended"] = true
      modifiedValues["is_esrp_loan_covid_enhanced"] = false
      modifiedValues["esrp_loan_interest_rate"] = null
      modifiedValues["esrp_loan_term_years"] = null
    }
    if (isNew) {
      return await addGoal({
        scenario_id: scenario.id,
        household_id: household.id,
        ...modifiedValues
      })
    } else {
      return await updateGoal({ id: goal.id, ...modifiedValues })
    }
  }

  const onDelete = async () => {
    await deleteGoal({ id: goal.id, scenario_id: scenario.id })
    return true
  }
  return (
    <WorkPauseFormContainer
      {...{
        submit,
        onDelete,
        values,
        isNew,
        peopleHsa,
        subtypeOptions,
        peopleOptions,
        ...formProps
      }}
    />
  )
}

export default WorkPause
